export default __webpack_public_path__ + "static/media/illustration-algocare-w@2x.51d759ae.png";